import { Navigation } from 'types';
import AppConstants from 'constants/AppConstants';

export function set(request: Partial<Navigation>): BaseTockAction<Partial<Navigation>> {
  return {
    type: AppConstants.NAVIGATION_SET,
    payload: request,
  };
}

export function incrementalUpdate(
  request: Partial<Navigation>
): BaseTockAction<Partial<Navigation>> {
  return {
    type: AppConstants.NAVIGATION_INCREMENTAL_UPDATE,
    payload: request,
  };
}
